<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
     stroke-linecap="round" stroke-linejoin="round" class="w-5">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
  <rect x="4" y="4" width="6" height="5" rx="2"></rect>
  <rect x="4" y="13" width="6" height="7" rx="2"></rect>
  <rect x="14" y="4" width="6" height="16" rx="2"></rect>
</svg>
